//
export const GET_ZONE = 'GET_ZONE';
export const GET_AREA = 'GET_AREA';
export const GET_FACILITY_TYPE = 'GET_FACILITY_TYPE';

export const GET_FACILITIES = "GET_FACILITIES";
export const GET_FACILITY = "GET_FACILITY";
export const GET_PLANS = "GET_PLANS";